import { BmarkFixingsManagerService } from "app/bfx-bmark-summary/services/bmark-fixings-manager.service";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { Injectable, ComponentFactoryResolver } from "@angular/core";
import { BfxBlotterFilterService } from "../../bfx-blotter-filter/bfx-blotter-filter.service";
import { BfxBlotterFilter } from "../../bfx-blotter-filter/bfx-blotter-filter.constants";
import { BfxSoundsService } from "../../bfx-common/services/bfx-sounds.service";
import {
  ActiveUserProfilePromiseService,
  OrderDataPromiseLookupService,
  SystemConfigPromiseService,
  TradeDealPromiseLookupService,
  OpsIntPromiseLookupService,
  OrderDataActionPromiseService,
  TradeDealPromiseActionService,
  OrderAcceptancePromiseService,
  OrderSalesApprovalRequestPromiseService,
  INotificationEvent,
  IOrderNotifData,
  InterventionDataLookupService,
  IRateNotifData,
} from "shared/cubiq-services";
import { TranslateService } from "@ngx-translate/core";
import { BfxOrderBlotterFilteringService } from "../../bfx-blotter-orders/bfx-blotter-orders-filter.service";
import { BfxBlotterTradeFilterService } from "../..//bfx-blotter-trade/services/bfx-blotter-trade-filter.service";
import { BfxBlotterInterventionFilterService } from "../../bfx-blotter-intervention/services/bfx-blotter-intervention-filter.service";
import { BfxPopupNotificationData } from "../models/bfx-popup-notification-data.model";
import { Subject, Subscription, combineLatest, Observable } from "rxjs";
import { BfxPopupNotificationCommand } from "app/bfx-notifications/models/bfx-popup-notification-command.enum";
import { BfxBlotterOrdersActionService } from "../../bfx-blotter-orders/bfx-blotter-orders-action.service";
import { BfxTradeActionsService } from "../../bfx-blotter-trade/services/bfx-trade-actions.service";
import { BfxInterventionActionsService } from "../../bfx-blotter-intervention/services/bfx-intervention-actions.service";
import { BfxBlotterActionEvent } from "app/bfx-base-blotter/bfx-base-blotter-contextmenu.service";
import { BfxBlotterAction } from "shared/cubiq-services/model/contextmenu/bfx-base-blotter/BfxBlotterAction";
import { BfxBlotterOrdersContextMenuItemQuickFillState } from "shared/cubiq-services";
// import { forEach } from '@angular/router/utils/collection';//MARKED FOR REMOVAL ANGULAR UPGRADE
import { BfxPopupTriggerNotificationData } from "app/bfx-notifications/models/bfx-popup-trigger-notification-data.model";
import { moment, OrderDataImpl } from "shared/cubiq-model-multi-asset";

import { BfxPopupNotificatonSettingsService } from "../../bfx-common/services/bfx-popup-notifications-settings.service";
import { Router } from "@angular/router";
import { BfxPopupAcceptanceNewNotificationData } from "../models/bfx-popup-acceptance-new-notification-data.model";
import { BfxPopupCreditAndModifyFailNewNotificationData } from "../models/bfx-popup-credit-fail-new-notification-data.model";
import { BfxPopupCreditFailFillAndRejectedNotificationData } from "../models/bfx-popup-credit-fail-fill-and-rejected-notification-data.model";
import { BfxPopupCreditFailRevalNotificationData } from "../models/bfx-popup-credit-fail-reval-notification-data.model";
import { BfxPopupCreditFailForceDiNotificationData } from "../models/bfx-popup-credit-fail-force-di-notification-data.model";
import { BfxPopupAcceptanceTransferNotificationData } from "../models/bfx-popup-acceptance-transfer-notification-data.model";
import { BfxPopupAcceptanceModifyOutNotificationData } from "../models/bfx-popup-acceptance-modifyout-notification-data.model";
import { BfxPopupAcceptanceCancelNotificationData } from "../models/bfx-popup-acceptance-cancel-notification-data.model";
import { BfxPopupAcceptanceExpiryNotificationData } from "../models/bfx-popup-acceptance-expiry-notification-data.model";
import { BfxPopupAcceptanceMigrationNotificationData } from "../models/bfx-popup-acceptance-migration-notification-data.model";
import { BfxPopupEventSetting } from "../../bfx-user-settings/model/bfx-popup-event-setting";
import { BfxPopupAcceptanceTriggerExpiryNotificationData } from "../models/bfx-popup-acceptance-trigger-expiry-notification-data.model";

import * as CubiqServices from "shared/cubiq-services";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

import { OENotificationsService } from "app/order-entry/services/basic/oe-notifications.service";
import { GoldenLayoutService } from "app/golden-layout/golden-layout-service";
import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";
import { NotificationService } from "shared/cubiq-services/lookup/notification/impl/NotificationService";
import { BFXNotificationEventType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationEventType";
import { BFXNotificationType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationType";
import { BFXNotificationSubType } from "../../../shared/cubiq-services/model/core/notifications/BFXNotificationSubType";
import { IInterventionNotifData } from "../../../shared/cubiq-services/model/core/notifications/IInterventionNotifData";
import { takeUntil } from "rxjs";
import { IBmarkFixingUpdateNotifData } from "shared/cubiq-services/model/core/notifications/IBmarkFixingUpdateNotifData";
import { BmarkClientOrdersFilterService } from "app/bfx-bmark-summary/blotters/client-orders/services/bmark-client-orders-filter.service";
import { BmarkOrderData } from "shared/cubiq-services/model/benchmarks/BmarkOrderData.model";
import { IConnectionMonitorNotifData } from "shared/cubiq-services/model/core/notifications/IConnectionMonitorNotifData";
import { IExportImportNotifData } from "shared/cubiq-services/model/core/notifications/IExportImportNotifData";
import { IAlgoInflightFailedData } from "shared/cubiq-services/model/core/notifications/IAlgoInflightFailedData";
import { IInterventionFixingRateReqAltNotifData } from "shared/cubiq-services/model/core/notifications/IInterventionFixingRateReqAltNotifData";
import { BfxInterventionContextMenuItemState } from "app/bfx-blotter-intervention/models/bfx-intervention-contextmenu.models";
import { OrderTypeHelper } from "shared/cubiq-services/model/orders/OrderTypeHelper";
import { BfxSysConfigUtilService } from "shared/auth-services";
import { BfxPopupSettingProviderService } from "app/bfx-notifications/services/bfx-popup-setting-provider.service";
// import { BfxCommsOpsIntService } from "app/bfx-blotter-ops-int/services/bfx-comms-ops-int.service";

const ALGO_INFLIGHT_ID_PREFIX: string = "inflight-";
const ALGO_INFLIGHT_FAILED_ID_PREFIX: string = "inflight_failed-";
const FROM_MAKER = "popup.notification.from.maker";
const NO_MIGRATION = "popup.notification.no.migration";
const FROM_MIGRATION = "popup.notification.from.migration";

const ACCEPTANCE_NOTIF_TYPES: BFXNotificationType[] = [
  BFXNotificationType.ACCEPTANCE_NEEDED,
  BFXNotificationType.BMARK_NEW_ORDERS,
];

/**
 * TODO: consider adding GENERIC_ERROR, others
 */
const NO_FOOTER_NOTIF_TYPES: BFXNotificationType[] = [BFXNotificationType.NETTING_FAILED];

@Injectable()
export class BfxPopupNotificationService {
  // private notifMap: Map<BFXNotificationType, BfxPopupEventSetting> = new Map();
  // protected notifTypes: Array<BFXNotificationType> = [];
  // private filterMap: Map<string, BfxBlotterFilter> = new Map();
  private popupNotificationMap: Map<string, BfxPopupNotificationData> = new Map();
  private popupSubscriptionMap: Map<string, Subscription> = new Map();
  private itemIdTypeMap: Map<string, string> = new Map();

  private popsSubject = new Subject<void>();
  public pops$: Observable<void> = this.popsSubject.asObservable();
  private pops: Array<BfxPopupNotificationData> = [];

  private closeIdSubject = new Subject<string>();
  public closeId$: Observable<string> = this.closeIdSubject.asObservable();

  private errorCounter: number = 0;

  //******************/
  //* Trigger Roles  */
  //******************/
  private hasReactivate: boolean;
  private hasFill: boolean;
  private slQuickFillEnabled: boolean;
  //*********************/
  //* Acceptance Roles  */
  //*********************/
  private hasDIAccept: boolean;
  private hasDIReject: boolean;
  private hasDIUnrestricted: boolean;
  private hasDISalesUnrestricted: boolean;
  private hasDISalesReject: boolean;
  private hasDISalesApprove: boolean;
  private hasDISalesClear: boolean;
  //*********************/
  //* Transfer Roles    */
  //*********************/
  private hasTransfer: boolean;
  //*****/
  private bmarkLongName: string;
  private bmarkShortName: string;
  private activeUser: CubiqServices.ActiveUser;

  private stopSub$ = new Subject<void>();

  private orderTypeHelper: OrderTypeHelper;

  constructor(
    private factoryResolver: ComponentFactoryResolver,
    private _router: Router,
    protected systemConfigService: SystemConfigPromiseService,
    private activeUserService: ActiveUserProfilePromiseService,
    private translationService: TranslateService,
    private popupNotificationSettingsService: BfxPopupNotificatonSettingsService,
    private filterService: BfxBlotterFilterService,
    private soundsService: BfxSoundsService,
    private orderService: OrderDataPromiseLookupService,
    private orderActionService: OrderDataActionPromiseService,
    private orderAcceptanceActionService: OrderAcceptancePromiseService,
    private tradeDealActionService: TradeDealPromiseActionService,
    private tradeDealService: TradeDealPromiseLookupService,
    private interventionService: InterventionDataLookupService,
    private orderFilteringService: BfxOrderBlotterFilteringService,
    private dealFilteringService: BfxBlotterTradeFilterService,
    private dIFilteringService: BfxBlotterInterventionFilterService,
    private blotterOrderActionService: BfxBlotterOrdersActionService,
    private blotterTradeActionService: BfxTradeActionsService,
    private blotterInterventionActionService: BfxInterventionActionsService,
    private orderSalesApprovalActionService: OrderSalesApprovalRequestPromiseService,
    // registers a CubiqTS.OpsIntEventImpl.name subscription with cubiq
    opsIntService: OpsIntPromiseLookupService,
    private goldenLayoutService: GoldenLayoutService,
    private _oeNotifications: OENotificationsService,
    private notifService: NotificationService,
    private _bmarkFilteringService: BmarkClientOrdersFilterService,
    private _bmarkDataLookup: CubiqServices.BenchmarkDataPrimaryLookupService,
    private _bmarkFixingManager: BmarkFixingsManagerService,
    private traderGroupService: CubiqServices.TraderGroupPromiseLookupService, //  private opsService: BfxCommsOpsIntService,
    protected algoStrategyLookupService: CubiqServices.AlgoStrategyLookupService,
    protected sysConfigUtil: BfxSysConfigUtilService,
    private popupSettingProviderService: BfxPopupSettingProviderService,
  ) {
    this.getSystemFlagsAndRolesForActions().then((done) => {
      this.activeUserService.getActiveUserData().then((data: CubiqServices.ActiveUser) => {
        this.activeUser = data;
        this.initializeSettingsAndSubscriptions();
        // NOTE: obs may run multiple times but in order to update both arrays
        // combineLatest(
        //   this.popupNotificationSettingsService.listenForSettingsUpdates(),
        //   this.popupNotificationSettingsService.getBmarkPopupNotificationsSettingsUpdates(),
        // ).subscribe(([settingsUpdates, bmarkSettingsUpdates]) => {
        //   // Don't clear existing settings as one of the values is bound to be empty
        //   this.mapTheNotificationSettings([...settingsUpdates, ...bmarkSettingsUpdates], false);
        // });
      });
    });
    // need a more global solution to this, worker and services should really be getting destroyed
    this._router.events.pipe(takeUntil(this.stopSub$)).subscribe((url: any) => {
      if (_router.url == "/logout") {
        logger.out.info(_router.url);
        this.closeAllPopupNotifications();
        this.stopSubscriptions();
      }
    });
    this.orderTypeHelper = new OrderTypeHelper(
      "",
      this.algoStrategyLookupService,
      this.sysConfigUtil,
    );
  }

  getSystemFlagsAndRolesForActions(): Promise<any> {
    return new Promise<any>((res, rej) => {
      Promise.all<any>([
        this.systemConfigService.hasRole(CubiqServices.Roles.ORDER_REACTIVATE), // 0
        this.systemConfigService.hasRole(CubiqServices.Roles.ORDER_FILL), // 1
        this.systemConfigService.getSystemConfig(CubiqServices.SysFeatures.slQuickFillEnabled), // 2
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_TRADER_ACCEPT), // 3
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_TRADER_REJECT), // 4
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_TRADER_UNRESTRICTED), // 5
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_TRADER_TRANSFER), // 6
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_SALES_UNRESTRICTED), // 7
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_SALES_REJECT), // 8
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_SALES_APPROVE), // 9
        this.systemConfigService.hasRole(CubiqServices.Roles.DI_SALES_CLEAR), // 10
        this.systemConfigService.getSystemConfig(CubiqServices.SysFeatures.fixingOrderLongName), // 11
        this.systemConfigService.getSystemConfig(CubiqServices.SysFeatures.fixingOrderShortName), // 12
      ])
        .then(
          (values) => {
            this.hasReactivate = values[0];
            this.hasFill = values[1];
            this.slQuickFillEnabled = values[2] === "N";
            this.hasDIAccept = values[3];
            this.hasDIReject = values[4];
            this.hasDIUnrestricted = values[5];
            this.hasTransfer = values[6];
            this.hasDISalesUnrestricted = values[7];
            this.hasDISalesReject = values[8];
            this.hasDISalesApprove = values[9];
            this.hasDISalesClear = values[10];
            this.bmarkLongName =
              typeof values[11] === "string" ? values[11].toUpperCase() : "BENCHMARK";
            this.bmarkShortName =
              typeof values[12] === "string" ? values[12].toUpperCase() : "BMARK";
            /////
            res(true);
          },
          (rejection) => {
            logger.out.error(
              "ERROR:BfxPopupNotificationService systemConfigService rejection:",
              rejection,
            );
            rej(false);
          },
        )
        .catch((reason) => {
          logger.out.error(
            "ERROR:BfxPopupNotificationService systemConfigService reason: ",
            reason,
          );
          rej(false);
        });
    });
  }

  // load the popup notification settings, if they are not saved to the profile,
  // we need to load a default per user, that last part still needs to be completed
  private initializeSettingsAndSubscriptions(): void {
    // Promise.all([
    //   this.popupNotificationSettingsService.getPopupNotificationsSettings(),
    //   this.popupNotificationSettingsService.getBmarkPopupNotificationsSettings(),
    // ]).then(([defaultNotificationSettings, bmarkPopupNotificationSettings]) => {
    // this.mapTheNotificationSettings([
    //   ...defaultNotificationSettings,
    //   ...bmarkPopupNotificationSettings,
    // ]);
    /* ORDER UPDATE SUBJECT  */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.ORDER_UPDATE_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe((event) => this.onOrderNotificationEvent(event));
    /* TRADE/DEAL UPDATE SUBJECT  */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.TRADE_UPDATE_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe((event) => this.onOrderNotificationEvent(event));
    /* INTERVENTION UPDATE SUBJECT */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.INTERVENTION_UPDATE_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe((event) => this.onOrderNotificationEvent(event));
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.FIXING_RATE_REQUIREMENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe((event) => {
        this.onInterventionFixingRateEvent(event);
      });
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.FWD_ROLL_PRICE)
      .pipe(takeUntil(this.stopSub$))
      .subscribe((event) => {
        this.onFwdRollPriceEvent(event);
      });
    /* OPS INTERVENTION UPDATE SUBJECT */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.OPS_INTERVENTION_UPDATE_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onOpsInterventionEvent.bind(this));
    /* ACTION FAIL */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.ACTION_FAIL_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onActionFailureNotificationEvent.bind(this));
    /* ORDER ENTRY */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.ORDER_ENTRY_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onOrderEntryNotificationEvent.bind(this));
    /* DETAIL FILL */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.DETAIL_FILL_UNLOCK_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onDetailFillUnlockEvent.bind(this));
    /* FIXING DEFINITION SUBJECT  */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.BMARK_FIXING_UPDATE_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onBmarkFixingUpdateEvent.bind(this));
    /* SYSTEM MONITOR EVENT SUBJECT */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.SYSTEM_MONITOR_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onSystemMonitorUpdateEvent.bind(this));
    /* EXPORT FOR IMPORT EVENT SUBJECT */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.EXPORT_ERROR_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onExportErrorEvent.bind(this));
    /* ALGO INFLIGHT EVENT SUBJECT */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.ALGO_INFLIGHT_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onAlgoInflightNotification.bind(this));
    /* INFLIGHT EVENT ERROR */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.ALGO_INFLIGHT_FAILED)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onInflightFailedNotification.bind(this));
    /* GENERIC MESSAGE EVENT */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.MESSAGE)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onMessageNotification.bind(this));
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.POSITION)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onPositionNotification.bind(this));
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.SESSION_END)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onSessionEndNotification.bind(this));
    /* ORDER ENTRY SUBJECT  */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.LIMIT_ORDER_ENTRY_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onOrderNotificationEvent.bind(this));
    /* BENCHMARK ORDER UPDATE SUBJECT  */
    this.notifService
      .getNotificationSubject(BFXNotificationEventType.BENCHMARK_ORDER_ENTRY_EVENT)
      .pipe(takeUntil(this.stopSub$))
      .subscribe(this.onOrderNotificationEvent.bind(this));
    /* NOT USED */
    // this.tradeDealActionFailureService=this.notifService.getNotificationSubject(BFXNotificationEventType.TRADE_DEAL_ACTION_FAIL_EVENT).subscribe(this.onActionFailureNotificationEvent.bind(this));
    // this.orderAcceptanceActionFailureService=this.notifService.getNotificationSubject(BFXNotificationEventType.ORDER_ACCEPTANCE_ACTION_FAIL_EVENT).subscribe(this.onActionFailureNotificationEvent.bind(this));
    // this.orderSalesApprovalActionFailureService=this.notifService.getNotificationSubject(BFXNotificationEventType.ORDER_SALES_APPROVAL_ACTION_FAIL_EVENT).subscribe(this.onActionFailureNotificationEvent.bind(this));
    // });
  }

  // *********************************************************************************** //
  // Configuration for each of the event types needs to be put into the following        //
  //                                                                                     //
  // *********************************************************************************** //

  // create the notification from an order payload
  createOrderNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let order: any = notifEvent.orderNotifData as IOrderNotifData;
    let isBmarkOrder =
      order.requestedOrderType ===
      (CubiqTS.RequestOrderType.BMARK || CubiqTS.RequestOrderType.BMALGO);

    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    if (notification instanceof BfxPopupAcceptanceNewNotificationData) {
      // Set flag so can determine type and actions
      notification.isBmarkOrder = isBmarkOrder;

      notification.isAutoHedged =
        order.fullOrderDataObj != null &&
        order.fullOrderDataObj.hedgingMode === CubiqTS.HedgingModeType.AUTO;
    } else if (notification instanceof BfxPopupAcceptanceCancelNotificationData) {
      // Set flag so can determine type and actions
      notification.isBmarkOrder = isBmarkOrder;
    }

    let amount: string =
      notifEvent.notifSubType === BFXNotificationSubType.FILL_FULL
        ? order.dealtTotalAmt
        : order.dealtTruncatedAmt;

    if (order.requestedOrderType !== CubiqTS.RequestOrderType.CALL && !isBmarkOrder) {
      order.as_notify_main_body = notification.body =
        order.instrument +
        " " +
        order.clientIntent +
        " " +
        amount +
        " " +
        order.fixedCode +
        " " +
        order.dealtTrackingRate;
      order.as_notify_body = amount + " " + order.fixedCode;
    } else if (isBmarkOrder) {
      order.as_notify_main_body = notification.body =
        order.instrument + " " + order.clientIntent + " " + amount + " ";
      order.as_notify_body = amount + " " + order.fixedCode;
    } else {
      order.as_notify_main_body = notification.body =
        order.instrument + " " + order.clientIntent + " " + order.dealtTrackingRate;
    }
    notification.bodyType = order.requestedOrderTypeAsString;

    // //populated for multiple items view table
    order.as_notify_time = order.orderDate;
    order.as_notify_instrument = order.instrument;
    order.as_notify_clientIntent = order.clientIntent;
    order.as_notify_dealtTracking = isBmarkOrder ? " " : order.dealtTrackingRate;
    order.as_notify_id = order.orderId.toString();
    order.as_notify_ref = order.orderRef;
    order.as_notify_requestedOrderType = order.requestedOrderTypeAsString;

    // ORDER ENTERED notifications have the algo type as type
    try {
      if (
        order.fullOrderDataObj != null &&
        ((notifEvent.notifType === BFXNotificationType.LIMITALGO_ORDER_ENTERED &&
          order.fullOrderDataObj.orderType === CubiqTS.OrderType.ALGO) ||
          (notifEvent.notifType === BFXNotificationType.BMARK_ORDER_ENTERED &&
            order.fullOrderDataObj.orderType === CubiqTS.OrderType.BMALGO))
      ) {
        let algoName = this.orderTypeHelper.getAlgoStrategyDescription(order.fullOrderDataObj);
        order.as_notify_requestedOrderType = algoName;
        notification.bodyType = algoName;
      }
    } catch (e) {
      logger.out.error(
        `${this.constructor.name}: Error updating order type for entry` +
          ` notification for order ${order.as_notify_id}: ${e}`,
        e,
      );
    }

    // BENCHMARK ORDER ENTERED notifications have the fixing as type
    try {
      if (
        order.fullOrderDataObj != null &&
        notifEvent.notifType === BFXNotificationType.BMARK_ORDER_ENTERED &&
        order.fullOrderDataObj.orderType === CubiqTS.OrderType.BENCHMARK &&
        order.fullOrderDataObj.fixingDetails?.reqFixingCd != null
      ) {
        let fixingTime = order.fullOrderDataObj.fixingDetails?.reqFixingCd;
        order.as_notify_requestedOrderType = fixingTime;
        notification.bodyType = fixingTime;
      }
    } catch (e) {
      logger.out.error(
        `${this.constructor.name}: Error updating order type for entry` +
          ` notification for order ${order.as_notify_id}: ${e}`,
        e,
      );
    }

    order.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_ORDER;

    // Populate required but missing desk ID and sales group, needed for action priv checks
    try {
      if (order.as_fv_deskId == null) {
        order.as_fv_deskId = order.deskId;
      }

      if (order.as_fv_salesGroupId == null) {
        order.as_fv_salesGroupId = order.fullOrderDataObj?.salesGroupId?.toString();
      }

      if (order.as_fv_targetDeskId == null) {
        order.as_fv_targetDeskId = order.fullOrderDataObj?.targetDeskId?.toString();
      }
    } catch (e) {
      logger.out.error(`${this.constructor.name}: Error constructing notification salesGroupId`, e);
    }

    notification.addToPayload(order);
    if (isBmarkOrder) {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
        [this.bmarkShortName],
      );
    } else {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
      );
    }
    notification.time = Date.now();
    notification.footer = order.clientName;
    notification.footerAction = order.as_notify_footerAction;

    return notification;
  }

  createUnsolicitedCancel(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notifdata: BfxPopupNotificationData = null;
    notifdata = this.createAltUnsolCanNotificationData(notifEvent);
    return notifdata;
  }

  // *********************************************************************************** //
  // Configuration for each of the event types needs to be put into the following        //
  //                                                                                     //
  // *********************************************************************************** //

  // create the notification from an order payload
  createAltUnsolCanNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let noMigration: string = "";
    let migratedTo: string = "";
    let order: any = notifEvent.orderNotifData as IOrderNotifData;

    let group: string = notifEvent.maker;
    let as_notify_body = this.translationService.instant(FROM_MAKER, [group]);
    order.as_notify_body = as_notify_body;
    order.as_notify_main_body = as_notify_body;
    notification.bodyType = order.requestedOrderTypeAsString;
    notification.body = order.as_notify_body;
    // //populated for multiple items view table
    order.as_notify_time = order.orderDate;
    order.fromMaker = as_notify_body;
    if (notifEvent.alternateGroupId !== null) {
      migratedTo = this.translationService.instant(FROM_MIGRATION, [notifEvent.alternateGroupName]);
      order.migragtedStr = migratedTo;
    } else {
      noMigration = this.translationService.instant(NO_MIGRATION);
      order.migragtedStr = noMigration;
    }

    order.unsolCanTable = true;
    order.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_OPS;

    notification.addToPayload(order);
    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );

    notification.time = Date.now();
    if (notifEvent.alternateGroupId == null) {
      notification.footer = noMigration;
    } else {
      notification.footer = migratedTo;
    }
    order.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_ORDER;
    notification.footerAction = BfxPopupNotificationCommand.POPUP_VIEW_ORDER;
    order.as_no_action = false;
    order.as_notify_id = order?.orderId?.toString();
    order.as_notify_ref = order.orderRef;
    order.opsId = notifEvent.opsId;
    return notification;
  }

  // TODO - create deal popup data
  createDealNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let deal: any = notifEvent.tradeNotifData as CubiqServices.ITradeNotifData;
    notification.idField = "id";
    if (deal.requestOrderType !== CubiqTS.RequestOrderType.CALL) {
      deal.as_notify_main_body =
        deal.productId +
        " " +
        deal.isBuy +
        " " +
        deal.truncatedDealtAmount +
        " " +
        deal.dealtCcy +
        " " +
        deal.allInClientRate;
      deal.as_notify_body = deal.truncatedDealtAmount + " " + deal.dealtCcy + " ";
    } else {
      deal.as_notify_main_body =
        deal.productId + " " + deal.requestOrderTypeAsString + " " + deal.allInClientRate;
    }
    notification.body = deal.as_notify_main_body;

    //populated for multiple items view table
    deal.as_notify_time = deal.dealDate;
    deal.as_notify_instrument = deal.productId;
    deal.as_notify_clientIntent =
      deal.requestOrderType !== CubiqTS.RequestOrderType.CALL
        ? deal.isBuy
        : deal.requestOrderTypeAsString;
    deal.as_notify_dealtTracking = deal.allInClientRate;
    deal.as_notify_id = deal.id.toString();
    deal.as_notify_ref = deal.dealRef;
    deal.as_notify_requestedOrderType = deal.requestOrderTypeAsString;
    deal.as_notify_notificationSettleDate = deal.as_search_valueDate;
    deal.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_DEAL;
    notification.addToPayload(deal);

    if (
      notifEvent.notifType === BFXNotificationType.BMARK_FILLED ||
      notifEvent.notifType === BFXNotificationType.BMARK_DEAL_FAILURE
    ) {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
        [this.bmarkShortName],
      );
    } else {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
      );
    }
    notification.time = Date.now();
    notification.bodyType = deal.requestOrderTypeAsString;
    notification.footer = deal.clientName;
    notification.footerAction = deal.as_notify_footerAction;

    return notification;
  }
  // TODO - create intervention popup data
  createInterventionNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let di: any = notifEvent.interventionNotifData as IInterventionNotifData;
    di.as_notify_main_body = di.currencyPair + " " + di.clientIntent + " " + di.bodyContent;
    notification.body = di.as_notify_main_body;

    // //populated for multiple items view table
    let diDate = moment(Date.now()).format("HH:mm:ss");
    di.as_notify_body = di.bodyContent;
    di.as_notify_time = di.diDate;
    di.as_notify_instrument = di.currencyPair;
    di.as_notify_id = di.orderId;
    di.as_notify_ref = di.orderRef;
    di.as_notify_clientIntent = di.clientIntent;
    di.as_notify_dealtTracking = di.requestRate;
    di.as_notify_requestedOrderType = di.requestedOrderTypeAsString;
    di.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_DI_DETAILS;
    notification.addToPayload(di);

    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    notification.time = Date.now();
    notification.bodyType = di.requestedOrderTypeAsString;
    notification.footer = di.clientName;
    notification.footerAction = di.as_notify_footerAction;
    return notification;
  }

  createInterventionFixingRateReqAltNotificationData(
    notifEvent: INotificationEvent,
  ): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );

    let di: any =
      notifEvent.interventionFixingRateReqAltNotifData as IInterventionFixingRateReqAltNotifData;
    di.as_notify_main_body = di.bodyContent;
    di.as_action_id = "PRICE IN DEALER INTERVENTION";
    notification.body = di.as_notify_main_body;
    notification.title = `${di.target} ${di.time}`;
    di.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_DI_PRICE;
    notification.idField = "requirementId";
    notification.time = Date.now();
    notification.fullBodyWidth = true;
    notification.footer = null;
    notification.footerAction = di.as_notify_footerAction;
    notification.addToPayload(di);
    return notification;
  }

  createFwdRollPriceNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );

    let di: any = notifEvent.fwdRollPriceNotifData;
    di.as_notify_main_body = di.bodyContent;
    di.as_action_id = "VIEW IN DEALER INTERVENTION";
    notification.body = di.as_notify_main_body;
    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );

    di.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_VIEW_DEALER_INTERVENTION;
    notification.idField = "portfolioId";
    notification.time = Date.now();
    notification.fullBodyWidth = true;
    notification.footer = null;
    notification.footerAction = di.as_notify_footerAction;
    notification.addToPayload(di);

    if (di.nonBm === true) {
      notification.bodyMultipleId = "DEALER_INTERVENTION_FWD_ROLL_PRICE_NONBM";
    }

    return notification;
  }

  createBmarkFixingUpdateNotificationData(
    notifEvent: INotificationEvent,
  ): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let dateTime = moment(Date.now()).format("HH:mm:ss");
    let fixingData: IBmarkFixingUpdateNotifData = notifEvent.bmarkFixingUpdateData;
    let id = notifEvent.bmarkFixingUpdateData.fixingId;
    let payloadItem = {
      id: id,
      as_notify_main_body: null,
      as_notify_time: dateTime,
      key: id,
      as_notify_footerAction: null,
      footer: "VIEW BENCHMARK SUMMARY",
      fixingData: null,
    };
    switch (notifEvent.notifType) {
      case BFXNotificationType.BMARK_SOFT_CUT_OFF:
      case BFXNotificationType.BMARK_HARD_CUT_OFF:
      case BFXNotificationType.BMARK_TRIGGERED:
        payloadItem.as_notify_main_body = this.translationService.instant(
          "popup.notification.body." + notification.typeStr,
          [fixingData.bmarkFixingData.displayCode + " " + fixingData.bmarkFixingData.displayTime],
        );
        break;
      default:
        logger.out.error(
          `ERROR: createBmarkFixingUpdateNotificationData : invalid notifType event ${notifEvent}`,
        );
        break;
    }
    payloadItem.as_notify_footerAction = null;
    payloadItem.fixingData = notifEvent.bmarkFixingUpdateData.bmarkFixingData;
    if (
      notifEvent.notifType === BFXNotificationType.BMARK_SOFT_CUT_OFF ||
      notifEvent.notifType === BFXNotificationType.BMARK_HARD_CUT_OFF ||
      notifEvent.notifType === BFXNotificationType.BMARK_TRIGGERED
    ) {
      notification.title = this.translationService.instant(
        "popup.notification.title." + notification.typeStr,
        [this.bmarkLongName],
      );
    }
    notification.time = Date.now();
    notification.body = payloadItem.as_notify_main_body;
    notification.footer = payloadItem.footer;
    notification.footerAction = payloadItem.as_notify_footerAction;
    notification.addToPayload(payloadItem);
    return notification;
  }

  createSystemMonitorEventNotificationData(
    notifEvent: INotificationEvent,
  ): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let notifData: IConnectionMonitorNotifData = notifEvent.connectionMonitorNotifData;

    notification.idField = "key";
    notification.body = notifData.bodyContent;

    let payloadItem = {
      as_notify_main_body: null,
      key: null,
      as_notify_time: null,
      as_notify_body: null,
    };
    payloadItem.as_notify_main_body = notification.body;
    payloadItem.as_notify_body = notification.body;
    payloadItem.key = notifData.eventId;

    notification.title = this.translationService.instant(
      "popup.notification.title." +
        BFXNotificationType[notifEvent.notifType] +
        "_" +
        BFXNotificationSubType[notifEvent.notifSubType],
    );
    payloadItem.as_notify_time = moment(notification.time).format("HH:mm:ss");
    notification.typeStr = BFXNotificationSubType[notifEvent.notifSubType];
    notification.body = payloadItem.as_notify_main_body;
    notification.fullBodyWidth = true;
    notification.addToPayload(payloadItem);

    return notification;
  }

  /**
   * Create notification data for export for import errors
   * @param notifEvent
   * @returns
   */
  createExportErrorNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let notificationData: IExportImportNotifData = notifEvent.exportImportNotifData;

    notification.idField = "key";
    notification.time = notificationData.time.getTime();

    let payloadItem: any = {
      as_notify_main_body: notificationData.bodyContent,
      as_notify_body: notificationData.bodyContent,
      key: notificationData.exportId + "-" + notificationData.bodyContent,
      as_notify_time: moment(notificationData.time).format("HH:mm:ss"),
    };

    notification.showTime = true;
    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    notification.fullBodyWidth = true;
    notification.body = payloadItem.as_notify_main_body;
    notification.typeStr = notificationData.exportId;
    notification.bodyMultipleId =
      "EXPORT_IMPORT" + (notificationData.noDownload === true ? "_NODOWNLOAD" : "");
    notification.addToPayload(payloadItem);

    return notification;
  }

  /**
   * Create notification data for failed inflight state change
   * @param notifEvent
   * @returns
   */
  createInflightFailedNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let notificationData: IAlgoInflightFailedData = notifEvent.algoInflighFailedData;

    notification.idField = "key";

    let textKey: string =
      BFXNotificationType[notifEvent.notifType] +
      "_" +
      BFXNotificationSubType[notifEvent.notifSubType];
    notification.body = notificationData.bodyContent;
    notification.bodyMultipleId = textKey;

    let payloadItem = {
      as_notify_main_body: null,
      key: null,
      as_notify_time: null,
      as_notify_body: null,
      as_notify_id: null,
      as_notify_ref: null,
      as_notify_footerAction: null,
      as_action_id: null,
    };
    payloadItem.as_notify_main_body = notification.body;
    payloadItem.as_notify_body = notification.body;
    payloadItem.as_notify_id = notificationData.orderId.toString();
    payloadItem.as_notify_ref = notificationData.orderRef;
    payloadItem.as_action_id = notificationData.orderRef;
    payloadItem.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_INFLIGHT_ORDER;

    // One inflight notification of any subtype overrides the other one
    payloadItem.key = ALGO_INFLIGHT_FAILED_ID_PREFIX + notificationData.orderId.toString();

    notification.title = this.translationService.instant(
      "popup.notification.title." +
        BFXNotificationType[notifEvent.notifType] +
        "_" +
        BFXNotificationSubType[notifEvent.notifSubType],
    );
    payloadItem.as_notify_time = moment(notification.time).format("HH:mm:ss");
    notification.typeStr = BFXNotificationSubType[notifEvent.notifSubType];
    notification.body = payloadItem.as_notify_main_body;
    notification.fullBodyWidth = true;
    notification.footerAction = payloadItem.as_notify_footerAction;
    notification.addToPayload(payloadItem);

    return notification;
  }

  // create the notification action failure from an order payload
  createActionFailureNotificationDataForOrderData(
    notifEvent: INotificationEvent,
  ): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let result: any = { ...notifEvent.actionFailedNotifData.failData };
    let bodyMessage: string = this.translationService.instant(
      "popup.notification.body." + notification.typeStr,
    );
    bodyMessage = bodyMessage + " " + result.orderId;
    result.as_notify_main_body = bodyMessage;
    notification.body = result.as_notify_main_body;

    // //populated for multiple items view table
    result.as_notify_body = bodyMessage;
    result.as_notify_time = result.orderDate;
    result.as_notify_ref = result.orderId.toString();
    result.as_notify_id = result.orderRef;
    result.as_notify_footerAction = this.getFailureFooterAction(notifEvent.notifType);
    notification.addToPayload(result);

    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    notification.time = Date.now();
    notification.footer =
      result.errorMessages != null
        ? this.handleErrorMessages(result.errorMessages)
        : result.errors != null
          ? this.handleErrorMessages(result.errors.errorMessages)
          : this.handleErrorMessages(result.lockErrors.errorMessages);
    notification.footerAction = result.as_notify_footerAction;
    return notification;
  }

  createActionFailureNotificationDataForManualPriceData(
    notifEvent: INotificationEvent,
  ): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let result: any = notifEvent.actionFailedNotifData.failData;
    let bodyMessage: string = this.translationService.instant(
      "popup.notification.body." + notification.typeStr,
    );
    let instrument: string = "";
    let dateTime = moment(Date.now()).format("HH:mm:ss");
    let errorMessage: string =
      result.errorMessages != null
        ? this.handleErrorMessages(result.errorMessages)
        : result.errors != null
          ? this.handleErrorMessages(result.errors.errorMessages)
          : this.handleErrorMessages(result.lockErrors.errorMessages);
    let requirementId: string = "";
    if (result instanceof CubiqTS.ManualPriceImpl) {
      requirementId = result.requirementId.toString();
      let requirementData: CubiqTS.FixingRateRequirementDataImpl =
        this.interventionService.getPricingRequirementData(requirementId);
      if (requirementData instanceof CubiqTS.FixingRateRequirementDataImpl) {
        instrument = requirementData.baseCurrencyCd + requirementData.nonBaseCurrencyCd;
        bodyMessage = bodyMessage + " " + instrument;
      }
    }
    let payloadItem = {
      requirementId: requirementId,
      as_notify_body: errorMessage, //instrument + ' -> ' +
      key: requirementId,
      as_notify_time: dateTime,
      as_notify_instrument: instrument,
      alternativeTable: true,
    };

    notification.addToPayload(payloadItem);
    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    notification.time = Date.now();
    notification.body = bodyMessage;
    notification.footer = errorMessage;
    // notification.footerAction = BfxPopupNotificaionCommand.POPUP_VIEW_ORDER;
    return notification;
  }

  createMessageNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    notification.idField = "key";
    let result: any = {};
    let bodyMessage: string = notifEvent.message;
    let title: string = notifEvent.title;

    result.as_notify_main_body = bodyMessage;
    notification.body = result.as_notify_main_body;

    // //populated for multiple items view table
    result.as_notify_body = bodyMessage;
    result.as_notify_id =
      result.as_notify_ref =
      result.key =
        `${BFXNotificationType[notifEvent.notifType]}-${Date.now()}`;
    notification.addToPayload(result);

    notification.title = this.translationService.instant("popup.notification.title.MESSAGE");
    if (title != null) {
      notification.title = title;
    }

    notification.time = Date.now();
    result.as_notify_time = moment(Date.now()).format("HH:mm:ss");
    result.as_no_action = true;
    result.as_no_footer = NO_FOOTER_NOTIF_TYPES.includes(notifEvent.notifType);

    notification.bodyMultipleId = "MESSAGE";
    notification.fullBodyWidth = true;

    return notification;
  }

  // create the notification action failure from an order payload
  createOrderEntryNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let result: any = notifEvent.orderEntryNotifData.response;
    let bodyMessage: string = notifEvent.orderEntryNotifData.message; //result.errorMessages != null ? this.handleErrorMessages(result.errorMessages) : result.errors != null ? this.handleErrorMessages(result.errors.errorMessages) : this.handleErrorMessages(result.lockErrors.errorMessages) ;
    //this.translationService.instant("popup.notification.body."+notification.typeStr, [orderId]);
    //bodyMessage = bodyMessage;
    result.as_notify_main_body = bodyMessage;
    notification.body = result.as_notify_main_body;

    // //populated for multiple items view table
    result.as_notify_body = bodyMessage;
    result.as_notify_time = notifEvent.orderEntryNotifData.date;
    result.as_notify_id = notifEvent.orderEntryNotifData.orderId.toString();
    result.as_notify_ref = notifEvent.orderEntryNotifData.orderRef;
    result.as_notify_footerAction = this.getFailureFooterAction(notifEvent.notifType);
    notification.addToPayload(result);

    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    notification.time = Date.now();
    notification.footer = null; //result.errorMessages != null ? this.handleErrorMessages(result.errorMessages) : result.errors != null ? this.handleErrorMessages(result.errors.errorMessages) : this.handleErrorMessages(result.lockErrors.errorMessages) ;
    notification.footerAction = result.as_notify_footerAction;
    return notification;
  }

  // create the notification action failure from an order payload
  public createDetailFillUnlockNotificationData(
    notifEvent: INotificationEvent,
  ): BfxPopupNotificationData {
    //orderId:string, type:BFXNotificationType, subType:BFXNotificationSubType, lockUser: string
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let payload: any = {};
    payload.orderId = notifEvent.detailFillUnlockNotifData.orderId;
    let user: string = notifEvent.detailFillUnlockNotifData.lockUser
      ? notifEvent.detailFillUnlockNotifData.lockUser
      : "other user";
    let bodyMessage: string = this.translationService.instant(
      "popup.notification.body." + notification.typeStr,
      [notifEvent.detailFillUnlockNotifData.orderId, user],
    );
    payload.as_notify_main_body = bodyMessage;
    notification.body = payload.as_notify_main_body;

    // // //populated for multiple items view table
    let date = moment(Date.now()).format("HH:mm:ss");
    payload.as_notify_body = bodyMessage;
    payload.as_notify_time = date;
    payload.as_notify_id = notifEvent.detailFillUnlockNotifData.orderId;
    notification.addToPayload(payload);

    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    notification.time = Date.now();
    return notification;
  }

  createAlgoInflightNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    let order: any = notifEvent.orderNotifData as IOrderNotifData;
    notification.idField = "key";

    let ruleType: CubiqTS.InflightRuleType = notifEvent.inflightCheckEventNotifData.ruleType;
    let textKey: string =
      BFXNotificationType[notifEvent.notifType] + "_" + CubiqTS.InflightRuleType[ruleType];
    notification.body = this.translationService.instant("popup.notification.body." + textKey, [
      notifEvent.inflightCheckEventNotifData.ruleName,
    ]);
    notification.bodyMultipleId = textKey;

    let payloadItem = {
      as_notify_main_body: null,
      key: null,
      as_notify_time: null,
      as_notify_body: null,
      as_notify_id: null,
      as_notify_ref: null,
      as_notify_footerAction: null,
      as_action_id: null,
    };
    payloadItem.as_notify_main_body = notification.body;
    payloadItem.as_notify_body = notification.body;
    payloadItem.as_notify_id = order.orderId.toString();
    payloadItem.as_notify_ref = order.orderRef;
    payloadItem.as_action_id = order.orderRef;
    payloadItem.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_INFLIGHT_ORDER;

    // One inflight notification of any subtype overrides the other one
    payloadItem.key = ALGO_INFLIGHT_ID_PREFIX + order.orderId.toString();

    notification.title = this.translationService.instant(
      "popup.notification.title." +
        BFXNotificationType[notifEvent.notifType] +
        "_" +
        BFXNotificationSubType[notifEvent.notifSubType],
    );
    payloadItem.as_notify_time = moment(notification.time).format("HH:mm:ss");
    notification.typeStr = BFXNotificationSubType[notifEvent.notifSubType];
    notification.body = payloadItem.as_notify_main_body;
    notification.fullBodyWidth = true;
    notification.footerAction = payloadItem.as_notify_footerAction;
    notification.addToPayload(payloadItem);

    return notification;
  }

  createPositionNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    notification.idField = "key";

    notification.body = this.translationService.instant(
      `popup.notification.body.${BFXNotificationType[notifEvent.notifType]}`,
    );

    let payloadItem = {
      as_notify_main_body: null,
      key: null,
      as_notify_time: null,
      as_notify_body: "null",
      as_notify_id: null,
      as_notify_ref: "SAVE POSITION",
      as_notify_footerAction: null,
      as_action_id: null,
    };
    payloadItem.as_notify_main_body = notification.body;
    payloadItem.as_notify_body = notification.body;
    payloadItem.as_notify_footerAction = BfxPopupNotificationCommand.POPUP_POSITION;

    notification.title = this.translationService.instant(
      "popup.notification.title." + BFXNotificationType[notifEvent.notifType],
    );
    notification.typeStr = BFXNotificationSubType[notifEvent.notifSubType];
    notification.body = payloadItem.as_notify_main_body;
    notification.fullBodyWidth = true;
    notification.footerAction = payloadItem.as_notify_footerAction;
    notification.closeAction = BfxPopupNotificationCommand.POPUP_POSITION_REVERT;
    notification.addToPayload(payloadItem);

    return notification;
  }

  private getFailureFooterAction(type: BFXNotificationType): BfxPopupNotificationCommand {
    let footerAction: BfxPopupNotificationCommand = BfxPopupNotificationCommand.POPUP_VIEW_ORDER;
    switch (type) {
      case BFXNotificationType.TRADE_ACTION_FAIL:
        footerAction = BfxPopupNotificationCommand.POPUP_VIEW_DEAL;
        break;
      case BFXNotificationType.INTERVENTION_ACTION_FAIL:
        footerAction = BfxPopupNotificationCommand.POPUP_VIEW_DI_DETAILS;
    }
    return footerAction;
  }

  // TODO - create rate popup data
  createRateNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    notification.time = Date.now();
    let rate: any = notifEvent.rateNotifData as IRateNotifData;

    notification.body = rate.baseCurrency + rate.nonBaseCurrency;
    let payloadItem = {
      as_notify_main_body: null,
      key: null,
      as_notify_time: null,
      as_notify_instrument: null,
    };
    switch (notifEvent.notifSubType) {
      case BFXNotificationSubType.STREAM_OFF_RATE_STALE:
        payloadItem.as_notify_main_body = this.translationService.instant(
          "popup.notification.body." + notification.typeStr,
          [rate.productCode],
        );
        payloadItem.key = rate.productCode;
        break;
      case BFXNotificationSubType.STREAM_OFF_STREAM_OFF:
        payloadItem.as_notify_main_body = this.translationService.instant(
          "popup.notification.body." + notification.typeStr,
          [rate.providerCode],
        );
        payloadItem.key = rate.providerCode;
        break;
    }
    payloadItem.as_notify_instrument = payloadItem.as_notify_main_body;
    notification.title = this.translationService.instant(
      "popup.notification.title." + notification.typeStr,
    );
    payloadItem.as_notify_time = rate.publishDate;
    notification.body = payloadItem.as_notify_main_body;
    notification.addToPayload(payloadItem);
    return notification;
  }

  createSessionEndNotificationData(notifEvent: INotificationEvent): BfxPopupNotificationData {
    let notification: BfxPopupNotificationData = this.getNotificationDataByType(
      notifEvent.notifType,
      notifEvent.notifSubType,
    );
    notification.idField = "key";
    let result: any = {};
    let bodyMessage: string = notifEvent.message;

    result.as_notify_main_body = bodyMessage;
    notification.body = result.as_notify_main_body;

    result.as_notify_body = bodyMessage;
    result.as_notify_id =
      result.as_notify_ref =
      result.key =
        `${BFXNotificationType[notifEvent.notifType]}-${Date.now()}`;
    notification.addToPayload(result);

    notification.title = this.translationService.instant("popup.notification.title.SESSION_END");
    notification.time = Date.now();
    result.as_notify_time = moment(Date.now()).format("HH:mm:ss");
    result.as_no_action = true;

    notification.fullBodyWidth = true;

    return notification;
  }

  getNotificationDataByType(
    type: BFXNotificationType,
    subType?: BFXNotificationSubType,
    idField?: string,
  ): BfxPopupNotificationData {
    switch (type) {
      case BFXNotificationType.TRIGGERED:
        return new BfxPopupTriggerNotificationData(
          this.activeUser,
          this.hasReactivate,
          this.hasReactivate,
          this.slQuickFillEnabled,
          this.traderGroupService.getBase(),
        );
      case BFXNotificationType.CANCELLED:
        return new BfxPopupNotificationData(type, "icon-close");
      case BFXNotificationType.BMARK_CANCELLED:
        return new BfxPopupNotificationData(type, "icon-close");
      case BFXNotificationType.UNSOLICITED_CANCEL:
        return new BfxPopupNotificationData(type, "icon-close");
      case BFXNotificationType.EXPIRED:
        return new BfxPopupNotificationData(type, "icon-bfx_expired");
      case BFXNotificationType.ACTIVATING:
        return new BfxPopupNotificationData(type, "icon-bfx_activating");
      case BFXNotificationType.ACTIVATED:
        return new BfxPopupNotificationData(type, "icon-bfx_activated");
      case BFXNotificationType.EXPIRING:
        return new BfxPopupNotificationData(type, "icon-bfx_expiring");
      case BFXNotificationType.SUSPENDED:
        return new BfxPopupNotificationData(type, "icon-pause_circle");
      case BFXNotificationType.UNSOLICITED_PAUSE_RESUME:
        switch (subType) {
          case BFXNotificationSubType.UNSOLICITED_PAUSE:
            let pauseNotif = new BfxPopupNotificationData(
              type,
              "icon-big-order-unsolicited-pause",
              BFXNotificationSubType.UNSOLICITED_PAUSE,
            );
            pauseNotif.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return pauseNotif;
          case BFXNotificationSubType.UNSOLICITED_RESUME:
            let resumeNotif = new BfxPopupNotificationData(
              type,
              "icon-big-order-unsolicited-pause",
              BFXNotificationSubType.UNSOLICITED_RESUME,
            );
            resumeNotif.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return resumeNotif;
        }
      case BFXNotificationType.SUSPENDING:
        return new BfxPopupNotificationData(type, "icon-bfx_suspending");
      case BFXNotificationType.FILLED:
        return new BfxPopupNotificationData(type, "icon-big-order-filled", subType);
      case BFXNotificationType.DEAL_FAILURE:
        return new BfxPopupNotificationData(type, "icon-big-stp-failed");
      case BFXNotificationType.DEALER_INTERVENTION:
        switch (subType) {
          case BFXNotificationSubType.CREDIT_FAIL_ENTRY:
          case BFXNotificationSubType.MODIFY_FAIL_ENTRY: {
            let nde: BfxPopupCreditAndModifyFailNewNotificationData =
              new BfxPopupCreditAndModifyFailNewNotificationData(
                subType,
                this.activeUser,
                this.hasDISalesApprove,
                this.hasDISalesReject,
                this.hasDISalesUnrestricted,
              );
            nde.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return nde;
          }
          case BFXNotificationSubType.CREDIT_FAIL_FILL:
          case BFXNotificationSubType.CREDIT_FAIL_REJECTED:
          case BFXNotificationSubType.CREDIT_FAIL_CANCELEXPIRY: {
            let ndf: BfxPopupCreditFailFillAndRejectedNotificationData =
              new BfxPopupCreditFailFillAndRejectedNotificationData(
                this.activeUser,
                this.hasDISalesApprove,
                this.hasDISalesReject,
                this.hasDISalesUnrestricted,
                subType,
              );
            ndf.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return ndf;
          }
          case BFXNotificationSubType.CREDIT_FAIL_REVAL: {
            let ndr: BfxPopupCreditFailRevalNotificationData =
              new BfxPopupCreditFailRevalNotificationData(
                this.activeUser,
                this.hasDISalesApprove,
                this.hasDISalesReject,
                this.hasDISalesUnrestricted,
              );
            ndr.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return ndr;
          }
          case BFXNotificationSubType.CREDIT_FAIL_FORCE_DI: {
            let ndfi: BfxPopupCreditFailForceDiNotificationData =
              new BfxPopupCreditFailForceDiNotificationData(
                this.activeUser,
                this.hasDISalesApprove,
                this.hasDISalesReject,
                this.hasDISalesUnrestricted,
              );
            ndfi.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return ndfi;
          }
          case BFXNotificationSubType.FIXING_RATE_REQUIREMENT:
          case BFXNotificationSubType.FWD_ROLL_PRICE:
            {
              let data = new BfxPopupNotificationData(
                type,
                "icon-big-dealer-intervention",
                subType,
              );
              data.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
              return data;
            }
            break;
        }
      case BFXNotificationType.BMARK_NEW_ORDERS:
      case BFXNotificationType.ACCEPTANCE_NEEDED:
        return this.createAcceptancePopupData(type, subType);
      case BFXNotificationType.MODIFIED:
        return new BfxPopupNotificationData(type, "icon-edit");
      case BFXNotificationType.BMARK_MODIFIED:
        return new BfxPopupNotificationData(type, "icon-edit");
      case BFXNotificationType.HOT:
        return new BfxPopupNotificationData(type, "icon-bfx_hot");
      case BFXNotificationType.UNLOCK:
        return new BfxPopupNotificationData(type, "icon-big-unlock");
      case BFXNotificationType.STREAM_OFF:
        switch (subType) {
          case BFXNotificationSubType.STREAM_OFF_RATE_STALE:
            return new BfxPopupNotificationData(type, "icon-error", subType, "key");
          case BFXNotificationSubType.STREAM_OFF_STREAM_OFF:
            return new BfxPopupNotificationData(type, "icon-error", subType, "key");
        }
        break;
      case BFXNotificationType.ORDER_ACTION_FAIL:
      case BFXNotificationType.TRADE_ACTION_FAIL:
      case BFXNotificationType.INTERVENTION_ACTION_FAIL:
      case BFXNotificationType.MESSAGE:
        switch (subType) {
          case BFXNotificationSubType.MANUAL_PRICE_FAIL:
            let acf_mpf: BfxPopupNotificationData = new BfxPopupNotificationData(
              type,
              "icon-big-panic-error",
              subType,
              "requirementId",
            );
            acf_mpf.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return acf_mpf;
          default:
            let acf: BfxPopupNotificationData = new BfxPopupNotificationData(
              type,
              "icon-big-panic-error",
              subType,
            );
            acf.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
            return acf;
        }
      case BFXNotificationType.SESSION_END:
        let acf: BfxPopupNotificationData = new BfxPopupNotificationData(
          type,
          "icon-big-panic-error",
          subType,
        );
        acf.typeStr = BFXNotificationType[type] + "_" + BFXNotificationSubType[subType];
        return acf;
      case BFXNotificationType.BMARK_SOFT_CUT_OFF:
      case BFXNotificationType.BMARK_HARD_CUT_OFF:
      case BFXNotificationType.BMARK_TRIGGERED:
        return new BfxPopupNotificationData(type, "icon-big-soft-cut-off", undefined, "id");
      default:
        return new BfxPopupNotificationData(type);
    }
  }

  private createAcceptancePopupData(
    type: CubiqServices.BFXNotificationType,
    subType: CubiqServices.BFXNotificationSubType,
  ) {
    switch (subType) {
      case BFXNotificationSubType.ACCEPTANCE_NEW:
        return new BfxPopupAcceptanceNewNotificationData(
          type,
          subType,
          this.activeUser,
          this.hasDIAccept,
          this.hasDIReject,
          this.hasDIUnrestricted,
        );
      case BFXNotificationSubType.ACCEPTANCE_MODIFY_IN:
        let nd: BfxPopupAcceptanceNewNotificationData = new BfxPopupAcceptanceNewNotificationData(
          type,
          subType,
          this.activeUser,
          this.hasDIAccept,
          this.hasDIReject,
          this.hasDIUnrestricted,
        );
        nd.iconClassName = "icon-edit";
        return nd;
      case BFXNotificationSubType.ACCEPTANCE_CANCEL:
        return new BfxPopupAcceptanceCancelNotificationData(
          type,
          this.activeUser,
          this.hasDIAccept,
          this.hasDIReject,
          this.hasDIUnrestricted,
        );
      case BFXNotificationSubType.ACCEPTANCE_EXPIRY:
        return new BfxPopupAcceptanceExpiryNotificationData(
          this.activeUser,
          this.hasDIAccept,
          this.hasDIUnrestricted,
        );
      case BFXNotificationSubType.ACCEPTANCE_MIGRATION:
        return new BfxPopupAcceptanceMigrationNotificationData(
          this.activeUser,
          this.hasDIAccept,
          this.hasDIUnrestricted,
        );
      case BFXNotificationSubType.ACCEPTANCE_MODIFY_OUT:
        return new BfxPopupAcceptanceModifyOutNotificationData(
          this.activeUser,
          this.hasDIAccept,
          this.hasDIReject,
          this.hasDIUnrestricted,
        );
      case BFXNotificationSubType.ACCEPTANCE_TRANSFER:
        return new BfxPopupAcceptanceTransferNotificationData(this.activeUser, this.hasTransfer);
      case BFXNotificationSubType.ACCEPTANCE_TRIGGER_EXPIRY:
        return new BfxPopupAcceptanceTriggerExpiryNotificationData(
          this.activeUser,
          this.hasDIAccept,
          this.hasDIUnrestricted,
        );
    }
    return new BfxPopupNotificationData(type, "icon-notification", subType);
  }

  // actions recieved from the popups need to call their appropriate action service
  private openDialogAttachSubscription(popupData: BfxPopupNotificationData): void {
    let bodyElement: Element = null;

    if (NativeDesktopSupport.isNativeDesktopContainer()) {
      bodyElement = NativeDesktopSupport.getNativeDesktopWindow().getNativeWindow().document.body;
    }

    let tpSt: string = popupData.typeStr;
    this.popupNotificationMap.set(tpSt, popupData);
    this.popupSubscriptionMap.set(
      tpSt,
      popupData
        .subscribeForCommand()
        .subscribe(
          (action: {
            command: BfxPopupNotificationCommand;
            popupData: BfxPopupNotificationData;
            selectedItemId?: string;
          }) => {
            let bae: BfxBlotterActionEvent;
            switch (action.command) {
              case BfxPopupNotificationCommand.POPUP_CLOSE:
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_DETAIL_FILL:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_DETAILFILL,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.body = bodyElement;
                this.doDetailFill(popupData);
                break;
              case BfxPopupNotificationCommand.POPUP_QUICK_FILL:
                this.doQuickFill(popupData);
                break;
              case BfxPopupNotificationCommand.POPUP_VIEW_DEAL:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_TRADE_VIEW_TRADE_DETAILS,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.body = bodyElement;
                this.blotterTradeActionService.onViewTradeDetails(bae);
                break;
              case BfxPopupNotificationCommand.POPUP_INFLIGHT_ORDER:
                try {
                  let popupIds: string[] =
                    action.selectedItemId != null
                      ? [action.selectedItemId]
                      : popupData.payloadIds.map((id) =>
                          id
                            .replace(ALGO_INFLIGHT_ID_PREFIX, "")
                            .replace(ALGO_INFLIGHT_FAILED_ID_PREFIX, ""),
                        );
                  if (
                    action.selectedItemId != null &&
                    Array.isArray(popupData.payload) &&
                    popupData.payload.length > 0
                  ) {
                    let payload: any = popupData.payload.find(
                      (p) => p.as_action_id == action.selectedItemId,
                    );
                    if (payload != null && payload.key != null) {
                      popupIds = [
                        payload.key
                          .replace(ALGO_INFLIGHT_ID_PREFIX, "")
                          .replace(ALGO_INFLIGHT_FAILED_ID_PREFIX, ""),
                      ];
                      payload.orderRef = action.selectedItemId;
                    }
                  }
                  bae = new BfxBlotterActionEvent(
                    BfxBlotterAction.ACTION_VIEW_DETAILS,
                    null,
                    popupIds,
                    popupData.payload,
                  );
                  bae.body = bodyElement;
                  this.blotterOrderActionService.onOrderDetails(bae);
                } catch (e) {
                  logger.out.error(
                    `${this.constructor.name}: Failed to process action on inflight order popup notification ${e}`,
                  );
                }
                break;
              case BfxPopupNotificationCommand.POPUP_VIEW_ORDER:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_VIEW_DETAILS,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );

                try {
                  if (
                    action?.selectedItemId != null &&
                    popupData?.payloadIds.includes(action.selectedItemId) &&
                    Array.isArray(popupData?.payload)
                  ) {
                    let selectedData = popupData.payload.filter(
                      (o) => o.orderId == action.selectedItemId,
                    );
                    if (selectedData.length == 1) {
                      bae.selectedIds = [action.selectedItemId];
                      bae.selectedItems = selectedData;
                    }
                  } else if (
                    action?.selectedItemId != null &&
                    Array.isArray(bae.selectedIds) &&
                    bae.selectedIds.length == 1 &&
                    bae.selectedIds[0] == null
                  ) {
                    bae.selectedIds = [action.selectedItemId];
                  }
                } catch (e) {
                  logger.out.error(
                    `${this.constructor.name}: Failed to find selected item on view order popup notification ${e}`,
                  );
                }

                bae.body = bodyElement;
                this.blotterOrderActionService.onOrderDetails(bae);
                break;
              case BfxPopupNotificationCommand.POPUP_REACTIVATE:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_REACTIVATE,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.body = bodyElement;
                this.blotterOrderActionService.onOrderReactivate(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_DI_ACCEPT:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_ACCEPT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["acceptanceState"];
                bae.body = bodyElement;
                this.blotterOrderActionService.onOrderAccept(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_DI_ACCEPT_TOPSIDE:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_ACCEPT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["acceptanceState"];
                bae.itemState["callOrderRateSide"] = CubiqTS.RateSideType.BID;
                bae.body = bodyElement;
                this.blotterOrderActionService.onOrderAccept(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_DI_ACCEPT_DOWNSIDE:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_ACCEPT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["acceptanceState"];
                bae.itemState["callOrderRateSide"] = CubiqTS.RateSideType.OFFER;
                this.blotterOrderActionService.onOrderAccept(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_DI_ACCEPT_INTO:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_ACCEPT_INTO,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["acceptanceState"];
                bae.body = bodyElement;
                this.blotterOrderActionService.onOrderAcceptInto(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_DI_REJECT:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_ORDER_REJECT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["acceptanceState"];
                bae.body = bodyElement;
                this.blotterOrderActionService.onOrderReject(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_VIEW_DI_DETAILS:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_VIEW_DETAILS,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["itemState"] != undefined ? popupData["itemState"] : {};
                bae.itemState["referencedOrderIds"] = popupData.payloadIds;
                bae.body = bodyElement;
                this.blotterInterventionActionService.onViewDetails(bae);
                break;
              case BfxPopupNotificationCommand.POPUP_VIEW_DI_PRICE:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_MANUAL_PRICE,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["itemState"] != undefined ? popupData["itemState"] : {};
                bae.itemState["referencedOrderIds"] = popupData.payloadIds;
                bae.body = bodyElement;
                this.showIntervention();
                this.blotterInterventionActionService.onPrice(bae);
                break;
              case BfxPopupNotificationCommand.POPUP_VIEW_DEALER_INTERVENTION:
                this.showIntervention();
                break;
              case BfxPopupNotificationCommand.POPUP_INTERVENTION_APPROVE:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_APPROVE,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["itemState"];
                bae.itemState["referencedOrderIds"] = popupData.payloadIds;
                bae.body = bodyElement;
                this.blotterInterventionActionService.onApprove(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_INTERVENTION_REJECT:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_REJECT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["itemState"];
                bae.itemState["referencedOrderIds"] = popupData.payloadIds;
                bae.body = bodyElement;
                this.blotterInterventionActionService.onReject(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_INTERVENTION_TRADER_ACCEPT:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_ACCEPT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = this.adaptInterventionItemState(
                  (popupData as BfxPopupAcceptanceNewNotificationData).acceptanceState,
                );
                this.blotterInterventionActionService.onAccept(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_INTERVENTION_TRADER_REJECT:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_TRADER_REJECT,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = this.adaptInterventionItemState(
                  (popupData as BfxPopupAcceptanceNewNotificationData).acceptanceState,
                );
                this.blotterInterventionActionService.onTraderReject(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
              case BfxPopupNotificationCommand.POPUP_INTERVENTION_CANCEL:
                bae = new BfxBlotterActionEvent(
                  BfxBlotterAction.ACTION_DI_CANCEL,
                  null,
                  popupData.payloadIds,
                  popupData.payload,
                );
                bae.itemState = popupData["itemState"];
                bae.itemState["referencedOrderIds"] = popupData.payloadIds;
                bae.body = bodyElement;
                this.blotterInterventionActionService.onCancel(bae);
                this.closePopupNotification(popupData.typeStr);
                break;
            }
          },
        ),
    );
  }

  doQuickFill(popupData: BfxPopupNotificationData) {
    let quickState: BfxBlotterOrdersContextMenuItemQuickFillState =
      new BfxBlotterOrdersContextMenuItemQuickFillState();

    // need to flag warnings etc here in the quickState
    popupData.payload.forEach((order) => {
      // is external?
      if (order.isExternal == "Yes") {
        quickState.warnings.show = true;
        quickState.warnings.external.display = true;
        quickState.warnings.external.ids.push(order.orderId.toString());
        quickState.warnings.external.orderRefs.push(order.orderRefs.toString());
      }
      // is in transfer?
      if (
        order.targetDeskId !== undefined &&
        order.targetDeskId !== null &&
        order.targetDeskId !== "-"
      ) {
        quickState.warnings.show = true;
        quickState.warnings.transfer.display = true;
        quickState.warnings.transfer.ids.push(order.orderId.toString());
        quickState.warnings.transfer.orderRefs.push(order.orderRefs.toString());
      }
      // order is about to expire
      if (order.selection && order.selection.indexOf("icon-bfx_order_expiring") > -1) {
        quickState.warnings.show = true;
        quickState.warnings.expired.display = true;
        quickState.warnings.expired.ids.push(order.orderId.toString());
        quickState.warnings.expired.orderRefs.push(order.orderRefs.toString());
      }
      // order credit failed and waiting approval in DI
      if (order.selection && order.selection.indexOf("icon-bfx_failed_credit") > -1) {
        quickState.warnings.show = true;
        quickState.warnings.credit_check.display = true;
        quickState.warnings.credit_check.ids.push(order.orderId.toString());
        quickState.warnings.credit_check.orderRefs.push(order.orderRefs.toString());
      }
    });
    let bae: BfxBlotterActionEvent = new BfxBlotterActionEvent(
      BfxBlotterAction.ACTION_ORDER_QUICKFILL,
      null,
      popupData.payloadIds,
      popupData.payload,
      quickState,
    );
    if (NativeDesktopSupport.isNativeDesktopContainer())
      bae.body = NativeDesktopSupport.getNativeDesktopWindow().getNativeWindow().document.body;
    this.blotterOrderActionService.onQuickFill(bae);
    this.closePopupNotification(popupData.typeStr);
  }

  doDetailFill(popupData: BfxPopupNotificationData) {
    let quickState: BfxBlotterOrdersContextMenuItemQuickFillState =
      new BfxBlotterOrdersContextMenuItemQuickFillState();

    // need to flag warnings etc here in the quickState
    popupData.payload.forEach((order) => {
      // is external?
      if (order.isExternal == "Yes") {
        quickState.warnings.show = true;
        quickState.warnings.external.display = true;
        quickState.warnings.external.ids.push(order.orderId.toString());
        quickState.warnings.external.orderRefs.push(order.orderRefs.toString());
      }
      // is in transfer?
      if (
        order.targetDeskId !== undefined &&
        order.targetDeskId !== null &&
        order.targetDeskId !== "-"
      ) {
        quickState.warnings.show = true;
        quickState.warnings.transfer.display = true;
        quickState.warnings.transfer.ids.push(order.orderId.toString());
        quickState.warnings.transfer.orderRefs.push(order.orderRefs);
      }
      // order is about to expire
      if (order.selection && order.selection.indexOf("icon-bfx_order_expiring") > -1) {
        quickState.warnings.show = true;
        quickState.warnings.expired.display = true;
        quickState.warnings.expired.ids.push(order.orderId.toString());
        quickState.warnings.expired.orderRefs.push(order.orderRefs.toString());
      }
      // order credit failed and waiting approval in DI
      if (order.selection && order.selection.indexOf("icon-bfx_failed_credit") > -1) {
        quickState.warnings.show = true;
        quickState.warnings.credit_check.display = true;
        quickState.warnings.credit_check.ids.push(order.orderId.toString());
        quickState.warnings.credit_check.orderRefs.push(order.orderRefs.toString());
      }
    });
    let bae: BfxBlotterActionEvent = new BfxBlotterActionEvent(
      BfxBlotterAction.ACTION_ORDER_QUICKFILL,
      null,
      popupData.payloadIds,
      popupData.payload,
      quickState,
    );
    if (NativeDesktopSupport.isNativeDesktopContainer())
      bae.body = NativeDesktopSupport.getNativeDesktopWindow().getNativeWindow().document.body;
    this.blotterOrderActionService.onDetailFill(bae);
    this.closePopupNotification(popupData.typeStr);
  }

  public showInbox(): void {
    this.goldenLayoutService.showInbox(false);
    this.closePopupNotification(BFXNotificationType[BFXNotificationType.ACCEPTANCE_NEEDED]);
  }

  public showIntervention(): void {
    this.goldenLayoutService.showIntervention(false);
    this.closePopupNotification(BFXNotificationType[BFXNotificationType.DEALER_INTERVENTION]);
  }

  public showBenchmarkSummary(
    notifType: BFXNotificationType,
    fixingData: CubiqServices.BmarkFixingData,
    isMulti: boolean,
  ) {
    this.goldenLayoutService.showBenchmarkSummary(false);
    // OMS-26988 (triggered) -> In the case of a notification for multiple benchmark fixes,
    // the View BM Summary button will simply open the BM Summary screen, without selecting a particular fix.
    if (notifType !== BFXNotificationType.BMARK_TRIGGERED || !isMulti) {
      this._bmarkFixingManager.refreshSelectedFixingData(fixingData);
    }
    this.closePopupNotification(BFXNotificationType[notifType]);
  }

  public showConnectionMonitor(): void {
    this.goldenLayoutService.showConnectionMonitor(false);
  }

  public showOpsIntervention(notifType: BFXNotificationType, opsId: string): void {
    this.selectOpsInterventionId(opsId);
    this.goldenLayoutService.showOpsInt(false);
    this.closePopupNotification(BFXNotificationType[notifType]);
  }

  selectOpsInterventionId(id: string) {
    // this.opsService.selectOpsId(id);
  }

  // *********************************************************************************** //
  // End Configurate                                                                     //
  //                                                                                     //
  // *********************************************************************************** //

  // notifications we revieve from the worker,
  protected onOrderNotificationEvent(row: INotificationEvent): void {
    if (row.notifType == BFXNotificationType.CLEAR_NOTIFICATION) {
      if (row.ids !== null)
        row.ids.forEach((id) => {
          this.removeNotificationById(id, row.clearAcceptanceOnly);
        });
    } else {
      let notifSetting = this.popupSettingProviderService.getNotificationSetting(row); //this.notifMap.get(row.notifType);
      // we get the row in an array with 1 item
      // let item = row[0];
      let filter: BfxBlotterFilter = notifSetting.filter
        ? this.filterService.getBlotterFilterSync(notifSetting.filter.id)
        : null;

      let orderDataObj: OrderDataImpl =
        row.orderNotifData != null ? row.orderNotifData.fullOrderDataObj : null;

      let blotterType = notifSetting.blotterType;
      if (
        row.notifType === BFXNotificationType.FILLED &&
        row.notifSubType === BFXNotificationSubType.FILL_FULL
      ) {
        blotterType = CubiqTS.BlotterType.ORDER;
      }

      switch (blotterType) {
        case CubiqTS.BlotterType.ORDER:
          if (row.notifType === BFXNotificationType.STREAM_OFF) {
            let stacked = this.addNotification(this.createRateNotificationData(row));
            if (notifSetting.disableAllAudio === false && stacked === false) {
              this.soundsService.playSoundById(notifSetting.audio.label);
            }
          } else if (row.notifType === BFXNotificationType.UNSOLICITED_CANCEL) {
            let stacked = this.addNotification(this.createUnsolicitedCancel(row));
            if (notifSetting.disableAllAudio === false && stacked === false) {
              this.soundsService.playSoundById(notifSetting.audio.label);
            }
          } else if (!filter || this.doesOrderFilterPass(orderDataObj, filter)) {
            let stacked = this.addNotification(this.createOrderNotificationData(row));
            if (notifSetting.disableAllAudio === false && stacked === false) {
              this.soundsService.playSoundById(notifSetting.audio.label);
            }
          } else {
            // remove because new notification may filtered out, so we need to remove previous
            if (row.orderNotifData?.orderId != null) {
              this.removeNotificationById(row.orderNotifData.orderId);
            }
          }

          break;
        case CubiqTS.BlotterType.INTERVENTION:
          if (!filter || this.doesDiFilterPass(row, filter)) {
            let stacked = this.addNotification(this.createInterventionNotificationData(row));
            if (notifSetting.disableAllAudio === false && stacked === false) {
              this.soundsService.playSoundById(notifSetting.audio.label);
            }
          }
          break;
        case CubiqTS.BlotterType.TRADE:
          let deal: CubiqTS.DealImpl =
            row.tradeNotifData != null ? row.tradeNotifData.completeTradeDeal : null;
          if (!filter || this.doesDealFilterPass(deal, filter)) {
            let stacked = this.addNotification(this.createDealNotificationData(row));
            if (notifSetting.disableAllAudio === false && stacked === false) {
              this.soundsService.playSoundById(notifSetting.audio.label);
            }
          }
          break;
        case CubiqTS.BlotterType.BENCHMARK:
          // NOTE: should be a simpler check
          // but not working any other way
          // it always sets row as orderToBeFiltered.
          let orderToBeFiltered: any =
            row.notifType === BFXNotificationType.BMARK_CANCELLED ||
            row.notifType === BFXNotificationType.BMARK_MODIFIED ||
            row.notifType === BFXNotificationType.BMARK_ORDER_ENTERED
              ? orderDataObj
              : row;
          if (!filter || this.doesBenchmarkFilterPass(orderToBeFiltered, filter)) {
            switch (row.notifType) {
              case BFXNotificationType.BMARK_FILLED:
              case BFXNotificationType.BMARK_DEAL_FAILURE: {
                let stacked = this.addNotification(this.createDealNotificationData(row));
                if (notifSetting.disableAllAudio === false && stacked === false) {
                  this.soundsService.playSoundById(notifSetting.audio.label);
                }
                break;
              }
              case BFXNotificationType.BMARK_NEW_ORDERS:
              case BFXNotificationType.BMARK_MODIFIED:
              case BFXNotificationType.BMARK_CANCELLED:
              case BFXNotificationType.BMARK_ORDER_ENTERED: {
                let stacked = this.addNotification(this.createOrderNotificationData(row));
                if (notifSetting.disableAllAudio === false && stacked === false) {
                  this.soundsService.playSoundById(notifSetting.audio.label);
                }
                break;
              }
              default:
                logger.out.error(`Bmark Notification -> NOT IMPLEMENTED YET !`);
                break;
            }
          }
          break;
      }
    }
  }
  onInterventionFixingRateEvent(event: INotificationEvent) {
    let notifSetting = this.popupSettingProviderService.getNotificationSetting(event);
    let stacked = this.addNotification(
      this.createInterventionFixingRateReqAltNotificationData(event),
    );
    if (notifSetting.disableAllAudio === false && stacked === false) {
      this.soundsService.playSoundById(notifSetting.audio.label);
    }
  }

  onFwdRollPriceEvent(event: INotificationEvent) {
    let notifSetting = this.popupSettingProviderService.getNotificationSetting(event);
    let stacked = this.addNotification(this.createFwdRollPriceNotificationData(event));
    if (notifSetting.disableAllAudio === false && stacked === false) {
      this.soundsService.playSoundById(notifSetting.audio.label);
    }
  }

  onOpsInterventionEvent(notifEvent: INotificationEvent): void {
    if (notifEvent.notifType == BFXNotificationType.CLEAR_NOTIFICATION) {
      this.removeNotificationById(notifEvent.ids[0]);
    } else {
      let event: any = notifEvent.rateNotifData as IRateNotifData;
      if (event.exceptionTypeId)
        switch (event.exceptionTypeId) {
          case CubiqTS.OpsExceptionType.FEED_FAILED:
            this.addNotification(this.createRateNotificationData(notifEvent));
        }
    }
  }

  onActionFailureNotificationEvent(result: INotificationEvent): void {
    if (
      result != null &&
      result.actionFailedNotifData != null &&
      result.actionFailedNotifData.failData instanceof CubiqTS.ManualPriceImpl
    ) {
      // manual price fail
      this.addNotification(this.createActionFailureNotificationDataForManualPriceData(result));
    } else {
      this.addNotification(this.createActionFailureNotificationDataForOrderData(result));
    }
  }

  onMessageNotification(event: INotificationEvent): void {
    this.addNotification(this.createMessageNotificationData(event));
  }

  onOrderEntryNotificationEvent(event: INotificationEvent): void {
    this.addNotification(this.createOrderEntryNotificationData(event));
  }

  onDetailFillUnlockEvent(event: INotificationEvent): void {
    this.addNotification(this.createDetailFillUnlockNotificationData(event));
  }

  onBmarkFixingUpdateEvent(notifEvent: INotificationEvent) {
    if (notifEvent != null) {
      if (notifEvent.notifType == BFXNotificationType.CLEAR_NOTIFICATION) {
        //logger.out.warn(`DEV-NOTIFICATIONS: Received [${BFXNotificationType[notifEvent.notifType]}] for ${notifEvent.ids.length} notifications: `, notifEvent.ids);
        if (Array.isArray(notifEvent.ids) && notifEvent.ids.length > 0) {
          notifEvent.ids.forEach((id) => {
            this.removeNotificationById(id);
          });
        }
      } else {
        let notifSetting = this.popupSettingProviderService.getNotificationSetting(notifEvent);
        let filter: BfxBlotterFilter = notifSetting.filter
          ? this.filterService.getBlotterFilterSync(notifSetting.filter.id)
          : null;
        let fixingData: CubiqServices.BmarkFixingData =
          notifEvent.bmarkFixingUpdateData.bmarkFixingData;
        let fixingID = notifEvent.bmarkFixingUpdateData.fixingId;
        let orderData: Array<BmarkOrderData> = notifEvent.bmarkFixingUpdateData.orderDataInFixing;

        if (!filter || this.doesBmarkOrderFilterPass(orderData, fixingData, filter)) {
          //logger.out.warn(`DEV-NOTIFICATIONS: Received [${BFXNotificationType[notifEvent.notifType]}] for ${fixingID} displayed`);
          let stacked = this.addNotification(
            this.createBmarkFixingUpdateNotificationData(notifEvent),
          );
          if (notifSetting.disableAllAudio === false && stacked === false) {
            this.soundsService.playSoundById(notifSetting.audio.label);
          }
        } else {
          //logger.out.warn(`DEV-NOTIFICATIONS: Clearing out [${BFXNotificationType[notifEvent.notifType]}] for ${fixingID} due to filtering`);
          // remove because new notification may filtered out, so we need to remove previous
          this.removeNotificationById(fixingID);
        }
      }
    }
  }

  onSessionEndNotification(event: INotificationEvent): void {
    this.addNotification(this.createSessionEndNotificationData(event));
  }

  onSystemMonitorUpdateEvent(notificationEvent: INotificationEvent): void {
    this.addNotification(this.createSystemMonitorEventNotificationData(notificationEvent));
  }

  onExportErrorEvent(notificationEvent: INotificationEvent): void {
    this.addNotification(this.createExportErrorNotificationData(notificationEvent));
  }

  protected onAlgoInflightNotification(row: INotificationEvent): void {
    if (row.notifType == BFXNotificationType.CLEAR_NOTIFICATION) {
      if (row.ids !== null) {
        row.ids.forEach(this.removeNotificationById.bind(this));
      }
    } else {
      let notifSetting = this.popupSettingProviderService.getNotificationSetting(row);
      let filter: BfxBlotterFilter = notifSetting.filter
        ? this.filterService.getBlotterFilterSync(notifSetting.filter.id)
        : null;
      let orderDataObj: OrderDataImpl =
        row.orderNotifData != null ? row.orderNotifData.fullOrderDataObj : null;

      if (!filter || this.doesOrderFilterPass(orderDataObj, filter)) {
        let stacked = this.addNotification(this.createAlgoInflightNotificationData(row));
        if (notifSetting.disableAllAudio === false && stacked === false) {
          this.soundsService.playSoundById(notifSetting.audio.label);
        }
      } else {
        // remove because new notification may filtered out, so we need to remove previous
        if (row.orderNotifData?.orderId != null) {
          this.removeNotificationById(ALGO_INFLIGHT_ID_PREFIX + row.orderNotifData.orderId);
        }
      }
    }
  }

  protected onInflightFailedNotification(notificationEvent: INotificationEvent): void {
    this.addNotification(this.createInflightFailedNotificationData(notificationEvent));
  }

  protected onPositionNotification(event: INotificationEvent): void {
    this.addNotification(this.createPositionNotificationData(event));
  }

  private doesBmarkOrderFilterPass(
    orderDataArray: Array<BmarkOrderData>,
    fixing: CubiqServices.BmarkFixingData,
    filter: BfxBlotterFilter,
  ) {
    let filteredOutOrderListSize: number = fixing.clientOrdersCount;
    let isOrderListNotEmpty = orderDataArray != null && orderDataArray.length > 0;
    if (isOrderListNotEmpty) {
      filteredOutOrderListSize = orderDataArray.filter((order: any) =>
        this._bmarkFilteringService.doFiltersPass(order, [filter]),
      ).length;
    }
    return filteredOutOrderListSize !== 0;
  }

  // does the order we received from the worker pass the filter? if no filter it will pass
  public doesOrderFilterPass(data: any, filter: BfxBlotterFilter): boolean {
    try {
      if (filter != null) {
        return this.orderFilteringService.doFiltersPass(data, [filter]);
      }
    } catch (error) {
      logger.out.error("Error while doing a order filter pass.", error);
    }

    return true;
  }

  // does the trade we recieved from the worker pass the filter? if no filter it will pass
  public doesDealFilterPass(data: any, filter: BfxBlotterFilter): boolean {
    try {
      if (filter != null) {
        return this.dealFilteringService.doFiltersPass(data, [filter]);
      }
    } catch (error) {
      logger.out.error("Error while doing a deal filter pass.", error);
    }

    return true;
  }

  // does the DI we recieved from the worker pass the filter? if no filter it will pass
  public doesDiFilterPass(data: any, filter: BfxBlotterFilter): boolean {
    try {
      if (filter != null) {
        return this.dIFilteringService.doFiltersPass(data, [filter]);
      }
    } catch (error) {
      logger.out.error("Error while doing a di filter pass.", error);
    }

    return true;
  }

  public doesBenchmarkFilterPass(data: any, filter: BfxBlotterFilter): boolean {
    try {
      if (filter != null) {
        return this._bmarkFilteringService.doFiltersPass(data, [filter], true);
      }
    } catch (error) {
      logger.out.error("Error while doing a bmark filter pass.", error);
    }
    return true;
  }

  getPopupNotifications(): Array<BfxPopupNotificationData> {
    return this.pops;
  }

  /**
   * Adds the notification by first removing it and than checking
   * if we have an existing popup of the same type. If this notification
   * is stacked than the method will return true
   * @param popupData
   * @returns true if the notificaiton is stacked, false otherwise
   */
  public addNotification(popupData: BfxPopupNotificationData): boolean {
    let stacked: boolean = false;

    if (popupData) {
      this.removeFromOthers(popupData);
      let existingPopup: BfxPopupNotificationData = this.popupNotificationMap.get(
        popupData.typeStr,
      );
      if (!existingPopup) {
        this.openDialogAttachSubscription(popupData);
        this.pops.push(popupData);
        this.popsSubject.next();
      } else {
        existingPopup.addToPayload(popupData.payload[0]);
        let bodyMultipleId: string =
          popupData.bodyMultipleId != null ? popupData.bodyMultipleId : popupData.typeStr;
        existingPopup.bodyMultiple = this.translationService.instant(
          "popup.notification.body.multiple." + bodyMultipleId,
          [existingPopup.payload.length],
        );
        existingPopup.bodyMultipleId =
          popupData.bodyMultipleId != null
            ? popupData.bodyMultipleId
            : existingPopup.bodyMultipleId;
        stacked = true;
      }
    }

    return stacked;
  }

  private removeNotificationById(id: string, acceptanceOnly: boolean = false) {
    let type: string = this.itemIdTypeMap.get(id);

    if (type != undefined && (!acceptanceOnly || this.isAcceptanceType(type))) {
      let existing: BfxPopupNotificationData = this.popupNotificationMap.get(type);
      if (existing) {
        existing.removeFromPayload(id);
        if (existing.payload.length <= 0) {
          this.closePopupNotification(type);
        } else {
          let bodyMultipleId: string =
            existing.bodyMultipleId != null ? existing.bodyMultipleId : existing.typeStr;
          existing.bodyMultiple = this.translationService.instant(
            "popup.notification.body.multiple." + bodyMultipleId,
            [existing.payload.length],
          );

          existing.body = existing.payload[0].as_notify_main_body;
          existing.bodyType = existing.payload[0].as_search_requestedOrderType;
        }
      }
      this.itemIdTypeMap.delete(id);
    }
  }

  private isAcceptanceType(type: string) {
    return ACCEPTANCE_NOTIF_TYPES.find((t) => BFXNotificationType[t] === type) != null;
  }

  private removeFromOthers(popupData: BfxPopupNotificationData): void {
    popupData.payloadIds.forEach((itemId) => {
      // remove from old
      this.removeNotificationById(itemId);
      // set ref for the new one
      this.itemIdTypeMap.set(itemId, popupData.typeStr);
    });
  }

  public closeAllPopupNotifications(): void {
    this.popupNotificationMap.forEach((dialogSubscription: any, key: string) => {
      this.closePopupNotification(key);
    });
  }

  public closePopupNotification(_dialogId: string): void {
    let index = this.pops.indexOf(this.popupNotificationMap.get(_dialogId));
    if (index > -1) {
      this.closeIdSubject.next(_dialogId);
      this.pops.splice(index, 1);
      this.popsSubject.next();
    }
    if (this.popupSubscriptionMap.get(_dialogId) != undefined) {
      this.popupSubscriptionMap.get(_dialogId).unsubscribe();
      this.popupSubscriptionMap.delete(_dialogId);
    }
    if (this.popupNotificationMap.get(_dialogId) != undefined) {
      try {
        this.popupNotificationMap.get(_dialogId).destroy();
      } catch (e) {
        logger.out.warn(
          `${this.constructor.name}.closeDialog(${_dialogId}) destroy() call failed %o`,
          e,
        );
      }
      this.popupNotificationMap.delete(_dialogId);
    }
  }

  private handleErrorMessages(errors: any[]): string {
    let message = "";
    errors
      .map((e) => JSON.parse(e))
      .forEach((e) => {
        if (e["id"] && e["id"].length > 0)
          message += this.translationService.instant(e["id"], e["args"]) + "\n";
      }) + "  ";
    return message;
  }

  private stopSubscriptions(): void {
    this.stopSub$.next();
    this.stopSub$.complete();
  }

  private adaptInterventionItemState(
    acceptanceState: CubiqServices.BfxBlotterOrdersContextMenuItemAcceptanceState,
  ) {
    // Need to map the Blotter Accept/Reject to intervention Accept/Reject for benchmarks
    const retState = new BfxInterventionContextMenuItemState();

    acceptanceState.actionRequests.accept.acceptance.forEach((ids, acceptanceType) => {
      retState.traderReference.set(acceptanceType, ids);
    });
    return retState;
  }
}
